import { Component, OnInit, Input } from '@angular/core';
import { Banche } from 'my-lib-sanfelici/my-lib-sanfelici';




@Component({
  selector: 'app-banca-view',
  templateUrl: './banca-view.component.html',
  styleUrls: ['./banca-view.component.css']
})
export class BancaViewComponent implements OnInit {
@Input() banca: Banche;
  constructor() { }

  ngOnInit() {
  }

}
